<template>
  <div class="employee">
    <BaseInput
      v-model="newEmployee.name"
      :error="hasError('name')"
      label="ФИО"
      id="new-employee-name"
      modifier="employee" />
    <BaseInput
      v-model="newEmployee.position"
      label="Должность"
      id="new-employee-post"
      modifier="employee" />
    <div
      v-if="configAccess.access_rights.main === 2"
      class="employee__group">
      <div class="employee__label">
        <label>Роль</label>
      </div>
      <div class="employee__input">
        <multiselect
          :class="[
            {'error': hasError('role')},
            'multiselect--employee-add multiselect--group'
          ]"
          v-model="newEmployee.role"
          :options="roles"
          group-values="list"
          group-label="label"
          :group-select="false"
          placeholder=""
          :allow-empty="false"
          :show-labels="false"
          :searchable="false"
          track-by="id"
          label="name" />
      </div>
    </div>
    <BaseInput
      v-model="newEmployee.phone"
      label="Телефон"
      id="new-employee-phone"
      modifier="employee"
      type="tel" />
    <BaseInput
      v-model="newEmployee.email"
      :error="hasError('email')"
      label="E-mail"
      id="new-employee-mail"
      modifier="employee"
      type="email" />
    <BaseInput
      @keydown.native="mixincheckNumberWithoutZero($event);checkLengthInput($event, 2)"
      v-model="newEmployee.max_discount"
      label="Макс. скидка, %"
      id="new-employee-max_discount"
      modifier="employee"
      type="number" />
    <BaseBtn
      @btnClick="create"
      :text="'Сохранить'"
      class="employee__btn" />
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions, mapGetters, mapState } from "vuex";
import Multiselect from 'vue-multiselect';
import inputValidate from '@/mixins/input-validate.mixin';

export default {
  name: 'PopupAddNewEmployee',

  components: {
    Multiselect,
    BaseBtn: () => import('@/components/base/BaseBtn'),
    BaseInput: () => import('@/components/base/BaseInput'), 
  },

  mixins: [
    inputValidate,
  ],

  data: () => ({
    newEmployee: {
      name: '',
      position: '',
      phone: '',
      email: '',
      max_discount: '',
      role: null,
    },

    permissions: [
      {
        id: 8,
        name: "Создание и редактирование сотрудников",
        isSelected: 0,
      },
      {
        id: 9,
        name: "Изменение цен",
        isSelected: 0,
      },
      {
        id: 10,
        name: "Просмотр журнала дилеров",
        isSelected: 0,
      },
      {
        id: 11,
        name: "Редактирование розничных заказов других сотрудников",
        isSelected: 0,
      },
      {
        id: 12,
        name: "Архивирование розничных заказов других сотрудников",
        isSelected: 0,
      },
      {
        id: 13,
        name: "Создавать и редактировать заказы поставщика",
        isSelected: 0,
      },
      {
        id: 14,
        name: "Отправлять заказы поставщику",
        isSelected: 0,
      },
      {
        id: 15,
        name: "Архивировать заказы поставщику",
        isSelected: 0,
      },
      {
        id: 16,
        name: "Редактировать статусы заказов от дилеров",
        isSelected: 0,
      },
    ],
  }),

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
      roles: state => state.account.accesses.roles,
    }),

    ...mapGetters('user', [
      'getUserId',
    ]),
  },

  validations () {
    const common = {
      name: {required},
      email: {required, email}
    };

    if (this.configAccess.access_rights.main === 2) {
      return {
        newEmployee: {
          ...common,
          role: {required},
        }
      }
    } else {
      return {
        newEmployee: {
          ...common,
        }
      }
    }
  },

  methods: {
    ...mapActions('account', [
      'createEmployee',
      'pullEmployees',
    ]),

    hasError(type) {
      return this.$v.newEmployee[type].$error;
    },

    create() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$danger('Пожалуйста, заполните все обязательные поля')
        return
      }

      this.togglePreload();
      const userId = this.getUserId
      this.createEmployee({
        ...this.newEmployee,
        perm: this.permissions,
        role_id: this.newEmployee.role ? this.newEmployee.role.id : null,
      })
        .then(res => {
          this.pullEmployees().then(res => {
            this.updatePopup(null, null);
            this.$success('Сотрудник успешно добавлен')
          })
        })
        .catch(error => {
          this.$danger(error.errorMessage)
        })
        .finally(() => {
          this.togglePreload();
        })
    },
  },
};
</script>

<style scoped lang="scss">
.employee {
  width: 100vw;
  max-width: 400px;
  background-color: #fff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.3);
  padding: 55px 30px 30px 30px;

  &__btn {
    margin-top: 30px;
  }

  &__group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 10px;

    @media(max-width: $desktop) {
      flex-direction: column;
    }
  }

  &__input {
    width: 50%;

    @media(max-width: $desktop) {
      width: 100%;
    }
  }

  &__label {
    font-size: 14px;
    line-height: 20px;
    color: #5E5E5E;
    padding-right: 10px;
    width: 50%;
    text-align: right;

    label {
      cursor: pointer;
      display: inline-block;
    }

    @media(max-width: $desktop) {
      width: 100%;
      padding-right: 0;
      margin-bottom: 2px;
      text-align: left;
    }
  }

  &__list {
    margin-bottom: 30px;
  }
}
</style>
